import script from "./helpVue.vue?vue&type=script&setup=true&lang=js"
export * from "./helpVue.vue?vue&type=script&setup=true&lang=js"

import "./helpVue.vue?vue&type=style&index=0&id=42c10aa2&lang=css"
import "./helpVue.vue?vue&type=style&index=1&id=42c10aa2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42c10aa2"]])

export default __exports__